// extracted by mini-css-extract-plugin
module.exports = {"formClass":"BC","setupPinButton":"BD","submitButton":"BE","cancelButton":"BF","enterPinHelpText":"BG"};